import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';

export default function useRouterTransition() {
  const [isInTransition, setIsInTransition] = useState(false);
  const router = useRouter();

  useEffect(() => {
    const handleStart = () => {
      setIsInTransition(true);
    };
    const handleStop = () => {
      setIsInTransition(false);
    };

    router.events.on('routeChangeStart', handleStart);
    router.events.on('routeChangeComplete', handleStop);
    router.events.on('routeChangeError', handleStop);

    return () => {
      router.events.off('routeChangeStart', handleStart);
      router.events.off('routeChangeComplete', handleStop);
      router.events.off('routeChangeError', handleStop);
    };
  }, [router]);

  return {
    isInTransition,
  };
}
